import React, { useEffect, useState, useContext } from 'react'
import styled from 'styled-components'
import { OverlayView } from '@react-google-maps/api'
import TripsContext from '../../contexts/TripsContext'
import { createVehicleInfoWindow } from '../../infowindow-utils'

type LatLng = {
    lat: any
    lng: any
}

type IProps = {
    vehicle?: any
    position: LatLng
    angle?: any
}

const OverlayCar = ({ vehicle, position, angle = 0 }: IProps): JSX.Element => {
    const { hardwareData, isNavegateToTrips, setInfoWindow } = useContext(TripsContext)

    const onClick = () => {
        const vehicle = isNavegateToTrips?.vehicle
        const data = hardwareData[isNavegateToTrips?.vehicle?.imei]
        const popup = createVehicleInfoWindow(data, vehicle, false)
        setInfoWindow(popup)
    }

    return (
        <>
            {position && (
                <OverlayView position={position} mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}>
                    <Car onClick={onClick} img="/content/plugin-widget-gmaps/car.svg" rotate={angle} />
                </OverlayView>
            )}
        </>
    )
}

export default React.memo(OverlayCar)

const Car = styled.div`
    background-image: ${({ img }) => `url(${img})`};
    background-repeat: no-repeat;
    width: 17.09px;
    height: 31px;
    transform: ${({ rotate }) => `rotate(${rotate}deg)`};
`
